import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-[40px] l:mb-[104px]" }
const _hoisted_2 = { class: "list-disc mb-6 pl-5" }
const _hoisted_3 = {
  href: "https://rvm-spb.ru/contacts",
  target: "_blank"
}
const _hoisted_4 = {
  href: "https://rvm-spb.ru/",
  target: "_blank"
}
const _hoisted_5 = {
  href: "https://rvm-spb.ru/categories/",
  target: "_blank"
}
const _hoisted_6 = {
  href: "https://rvm-spb.ru/excursion/",
  target: "_blank"
}
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "list-disc mb-6 pl-5" }

import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseContainer from '@/components/common/BaseContainer.vue';
import BaseReturn from '@/components/common/BaseReturn.vue';
import { useWindowSize } from '@vueuse/core';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Consent',
  setup(__props) {

const { width } = useWindowSize();
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseReturn, {
      text: _unref(t)('consent.title')
    }, null, 8, ["text"]),
    _createVNode(BaseContainer, null, {
      default: _withCtx(() => [
        _createVNode(BaseTypography, {
          text: _unref(t)('consent.text.1'),
          type: _unref(width) > 768 ? 'body' : 'body-m',
          class: "indent-8 mb-6"
        }, null, 8, ["text", "type"]),
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.2'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"]),
            _createElementVNode("a", _hoisted_3, [
              _createVNode(BaseTypography, {
                text: "https://rvm-spb.ru/contacts",
                type: _unref(width) > 768 ? 'body' : 'body-m',
                tag: "span",
                class: "underline"
              }, null, 8, ["type"])
            ])
          ]),
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.3'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"]),
            _createElementVNode("a", _hoisted_4, [
              _createVNode(BaseTypography, {
                text: "https://rvm-spb.ru/",
                type: _unref(width) > 768 ? 'body' : 'body-m',
                tag: "span",
                class: "underline"
              }, null, 8, ["type"])
            ])
          ]),
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.4'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"]),
            _createElementVNode("a", _hoisted_5, [
              _createVNode(BaseTypography, {
                text: "https://rvm-spb.ru/categories/",
                type: _unref(width) > 768 ? 'body' : 'body-m',
                tag: "span",
                class: "underline"
              }, null, 8, ["type"])
            ])
          ]),
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.5'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"]),
            _createElementVNode("a", _hoisted_6, [
              _createVNode(BaseTypography, {
                text: "https://rvm-spb.ru/excursion/",
                type: _unref(width) > 768 ? 'body' : 'body-m',
                tag: "span",
                class: "underline"
              }, null, 8, ["type"])
            ])
          ])
        ]),
        _createVNode(BaseTypography, {
          text: _unref(t)('consent.text.6'),
          type: _unref(width) > 768 ? 'body' : 'body-m'
        }, null, 8, ["text", "type"]),
        _createVNode(BaseTypography, {
          text: _unref(t)('consent.text.7'),
          type: _unref(width) > 768 ? 'body' : 'body-m',
          class: "indent-8 mb-6"
        }, null, 8, ["text", "type"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BaseTypography, {
            text: _unref(t)('consent.text.8'),
            type: _unref(width) > 768 ? 'body' : 'body-m',
            class: "indent-8",
            tag: "span"
          }, null, 8, ["text", "type"]),
          _createVNode(_component_router_link, { to: "/policy" }, {
            default: _withCtx(() => [
              _createVNode(BaseTypography, {
                text: _unref(t)('consent.text.9'),
                type: _unref(width) > 768 ? 'body' : 'body-m',
                class: "underline",
                tag: "span"
              }, null, 8, ["text", "type"])
            ]),
            _: 1
          })
        ]),
        _createVNode(BaseTypography, {
          text: _unref(t)('consent.text.10'),
          type: _unref(width) > 768 ? 'body' : 'body-m',
          class: "indent-8 mb-6"
        }, null, 8, ["text", "type"]),
        _createVNode(BaseTypography, {
          text: _unref(t)('consent.text.11'),
          type: _unref(width) > 768 ? 'body' : 'body-m',
          class: "indent-8 mb-6"
        }, null, 8, ["text", "type"]),
        _createVNode(BaseTypography, {
          text: _unref(t)('consent.text.12'),
          type: _unref(width) > 768 ? 'body' : 'body-m',
          class: "indent-8 mb-6"
        }, null, 8, ["text", "type"]),
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.13'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.14'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.15'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.16'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('consent.text.17'),
              type: _unref(width) > 768 ? 'body' : 'body-m',
              tag: "span"
            }, null, 8, ["text", "type"])
          ])
        ]),
        _createVNode(BaseTypography, {
          text: _unref(t)('consent.text.18'),
          type: _unref(width) > 768 ? 'body' : 'body-m',
          class: "indent-8"
        }, null, 8, ["text", "type"])
      ]),
      _: 1
    })
  ]))
}
}

})